const getStepIdByTag = (tag, userSteps) =>
  userSteps.find((step) => step.tag === tag)?.id

export default getStepIdByTag
